module.exports = __webpack_public_path__ + "img/banner-2026-en-v2.f1e1e12a.jpg";